export default __webpack_public_path__ + "static/media/Saira-Laghari.0f86a5dd.jpg";